'use client';

import { mergeThemeOverrides } from '@mantine/core';
import baseTheme from './base';
import darkThemeSpecific from './dark';
import lightThemeSpecific from './light';

export const light = mergeThemeOverrides(
	baseTheme,
	lightThemeSpecific
);
export const dark = mergeThemeOverrides(
	baseTheme,
	darkThemeSpecific
);
